export function validarCedula(cedula: string): boolean {
  if (!/^\d{10}$/.test(cedula)) return false;

  const provincia = parseInt(cedula.substring(0, 2), 10);
  if (provincia < 1 || provincia > 24) return false;

  const tercerDigito = parseInt(cedula[2], 10);
  if (tercerDigito >= 6) return false;

  const coef = [2,1,2,1,2,1,2,1,2];
  const digitos = cedula.split("").map(Number);

  let suma = 0;

  for (let i = 0; i < coef.length; i++) {
    let valor = digitos[i] * coef[i];
    if (valor >= 10) valor -= 9;
    suma += valor;
  }

  const decena = Math.ceil(suma / 10) * 10;
  const verificador = decena - suma === 10 ? 0 : decena - suma;

  return verificador === digitos[9];
}